import { render, staticRenderFns } from "./selectlanguage.vue?vue&type=template&id=01aded8e&"
import script from "./selectlanguage.js?vue&type=script&lang=js&"
export * from "./selectlanguage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\EmployeePortalUpdated\\Frontend\\EmployeePortal.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01aded8e')) {
      api.createRecord('01aded8e', component.options)
    } else {
      api.reload('01aded8e', component.options)
    }
    module.hot.accept("./selectlanguage.vue?vue&type=template&id=01aded8e&", function () {
      api.rerender('01aded8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/shared/common/inputs/selectlanguage.vue"
export default component.exports